module.exports = __webpack_public_path__ + "img/ciabatta.7763a3ba.jpg";